<template>
	<div>
		<div class="row">
			<!-- Content Column -->
			<div class="col-lg-12 mb-4">
				<!-- Project Card Example -->
				<div class="card shadow mb-4">
					<div class="card-header py-3 bg-tecq">
						<h6 class="m-0 font-weight-bold text-white">Search Results</h6>
					</div>
					<div class="card-body">
						<div class="table-responsive" style="max-height: 400px; overflow-y: auto">
							<table class="table">
								<thead>
									<tr class="bg-gradient-secondary">
										<th scope="col"><nobr>CPT Code</nobr></th>
										<th scope="col">Category</th>
										<th scope="col">Description</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in claimresults" :key="index">
										<td scope="row">{{ item.cpt_code }}</td>
										<td scope="row">{{ item.category }}</td>
										<td>{{ item.description }}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<!-- Show message if no results -->
						<p v-if="claimresults.length === 0" class="text-center text-muted mt-3">
							No results found or the code is not in our Auto Approval List
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "ClaimCheckerResult",
		props: ["claimresults"],

		data() {
			return {
				showCSV: false,
				headers: [],
				rows: [],
				showEngage: false,
				currentIndex: 0,
				currentMember: [],
			};
		},
		methods: {
			enableCSV() {
				this.showCSV = true;
			},
			disableCSV() {
				this.showCSV = false;
			},
			refreshMyList() {
				this.$refs.MemberMyList.refreshMyList();
			},
			engageMember(item_index) {
				//this.showEngage = true,
				this.currentMember = this.rows[item_index];

				$("#exampleModal").modal("show");
			},
			submitEngagement() {},
			currentMonthDate() {
				let new_date = new Date();
				let options = { year: "numeric", month: "2-digit" };
				return new_date.toLocaleDateString("en-US", options);
			},
			removeRecord(member_id) {
				this.rows = this.rows.filter((item) => item.member_identifier !== member_id);
			},
			getStatusText(is_valid) {
				return is_valid
					? '<span class="text-success">VALID</span>'
					: '<span class="text-danger">INVALID</span>';
			},
			getStatusTextOnly(is_valid) {
				return is_valid ? "VALID" : "INVALID";
			},
			downloadCSV() {
				const csvData = [];
				const headers = [
					"Member ID",
					"Claim ID",
					"Is Valid",
					"DOS",
					"Benefits Start",
					"Benefits End",
					"Benefits File Import Date",
				];

				// Add headers to CSV data
				csvData.push(headers.join(","));

				// Add rows of data
				this.claimresults.forEach((item) => {
					const row = [
						item.member_number,
						item.claim_id,
						this.getStatusTextOnly(item.is_valid),
						item.dos,
						item.benefits_start || "NA",
						item.benefits_end,
						item.imported_date,
					];
					csvData.push(row.join(","));
				});

				// Convert CSV data array into a Blob
				const blob = new Blob([csvData.join("\n")], { type: "text/csv" });

				// Create a download link
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement("a");
				a.href = url;
				a.download = "claim_results.csv";
				a.click();

				// Clean up
				window.URL.revokeObjectURL(url);
			},
		},
		mounted() {
			// axios.get('/members/json/newestmembers')
			//     .then(response => {
			//         // console.log(response);
			//         // this.headers = Object.keys(response.data[0]);
			//         this.rows = response.data;
			//     })
			//     .catch(error => {
			//         console.error(error);
			//     });
		},
	};
</script>
<style>
	.bg-tecq {
		background: #072c5c;
	}
	.btn-tecq {
		background: #3e4755;
		color: #fff;
	}
	/* Make the header sticky */
	.table-responsive thead tr {
		position: sticky;
		top: 0;
		background: #f8f9fa;
		z-index: 2;
	}
</style>
